var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasSurveySubmissions)?_c('Handsontable',{ref:"handsontableComponent",attrs:{"headers":_vm.headers,"values":_vm.values,"search":_vm.search,"is-readonly":_vm.isFocalPoint,"fields-to-style":_vm.fieldsToStyle,"styles":_vm.styles}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }